import { LS_TOKEN_KEY } from '~/providers/AuthenticationProvider';
import axios, { AxiosRequestTransformer } from 'axios';
import { ApiConfig } from '~/configs/api';
import { Api } from '../../.codegen/Api';

const AuthTransformer: AxiosRequestTransformer = (data: unknown, headers) => {
  const token = localStorage.getItem(LS_TOKEN_KEY);

  if (!token) {
    return data;
  }

  /**
   * useLocalStorage are saving strings surrounded by '"' which we need to remove
   */
  headers.Authorization = `Token ${token.replace(/"/g, '')}`;

  return data;
};

export const SSF = new Api({
  transformRequest: [AuthTransformer, ...(axios.defaults.transformRequest as AxiosRequestTransformer[])],
  baseURL: ApiConfig.baseUrl,
  paramsSerializer: {
    indexes: null,
  },
});
